module.exports = __webpack_public_path__ + "static/media/logo_urgently.6638ddac.svg";